import Request from './request'

export default class BookingService {
  static async PartnerGetMetaData(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/PartnerAPI/SystemConfigurations/getMetaData',
        data: data,
        token: false
      }).then((result = {}) => {
        const { statusCode } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          resolve(result)
        }
      })
    })
  }

  static async getBannerStationsList(filter) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/SystemPromoBanners/user/getList',
        data: filter
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(data)
        } else {
          return resolve({})
        }
      })
    })
  }
}
